module.exports = __webpack_public_path__ + "static/media/maintenance.4213fe27.svg";